/* ── Bara Bros Reward Notifications — bb-reward-notifications.js (Phase 16I) ── */
(function (root) {
  'use strict';

  if (root.BBRewardNotifications && root.BBRewardNotifications._ready) return;

  /* ── Default config (overridden by window.BB_NOTIF_CFG from Liquid) ── */
  var DEF = {
    enabled:             true,
    debugMode:           false,
    displayMode:         'auto',            // toast|banner|mini_modal|bottom_sheet|floating_badge|auto
    desktopPosition:     'top_right',
    mobilePosition:      'bottom_sheet',
    stackLimit:          3,
    autoDismissSeconds:  6,
    allowClose:          true,
    pauseOnHover:        true,
    showProgressBar:     true,
    reduceMotion:        true,
    stylePreset:         'liquid_glass',
    animationType:       'slide',
    enterDurationMs:     280,
    exitDurationMs:      220,
    enableIconAnimation: true,
    enableGlowPulse:     true,
    enableConfetti:      false,
    enableCoinSparkle:   false,
    confettiEvents:      ['vip_upgrade','milestone_unlocked','points_redeemed'],
    enableSound:         false,
    soundPreset:         'none',
    enableVibration:     false,
    iconMode:            'preset',
    iconStyle:           'filled',
    notifyOn: {
      daily_checkin:     true,
      points_earned:     true,
      points_redeemed:   true,
      coupon_claimed:    true,
      coupon_expiring:   true,
      vip_upgrade:       true,
      referral_pending:  true,
      referral_issued:   true,
      review_reward:     true,
      milestone_unlocked:true,
      mission_progress:  false,
      mission_completed: true,
      mission_rewarded:  true,
    },
    icons: {
      daily_checkin:    'check_circle',
      points_earned:    'sparkle',
      points_redeemed:  'coin',
      coupon_claimed:   'ticket',
      coupon_expiring:  'flame',
      vip_upgrade:      'crown',
      referral_pending: 'gift',
      referral_issued:  'gift',
      review_reward:    'star',
      milestone_unlocked:'trophy',
      mission_progress:  'lightning',
      mission_completed: 'trophy',
      mission_rewarded:  'sparkle',
    },
    customSvg:   {},
    textOverrides: {},
    showCta:     true,
    ctaLabels: {
      coupon:   'View Wallet',
      points:   'View Points',
      referral: 'View Referrals',
      review:    'View Rewards',
      vip:       'View VIP',
      missions:  'View Missions',
    },
    ctaRoutes: {
      coupon:   '/pages/coupons',
      points:   '/pages/coupons?tab=points',
      referral: '/pages/coupons?tab=referrals',
      review:    '/pages/coupons?tab=reviews',
      vip:       '/pages/coupons?tab=vip',
      missions:  '/pages/coupons?tab=missions',
    },
    // CSS variable overrides (applied to container)
    bgColor:            '',
    textColor:          '',
    subtextColor:       '',
    accentColor:        '',
    secondaryAccent:    '',
    borderColor:        '',
    iconColor:          '',
    progressColor:      '',
    shadowOpacity:      '',
    glowIntensity:      '',
    titleSize:          '',
    messageSize:        '',
    fontWeight:         '',
    titleTransform:     '',
    widthDesktop:       360,
    widthMobile:        340,
    borderRadius:       14,
    padding:            16,
    gap:                10,
    zIndex:             9999,
    safeAreaOffset:     0,
  };

  var cfg  = Object.assign({}, DEF);
  var _id  = 0;
  var _stack = [];  // [{id,timer,el}]
  var _container = null;

  /* ── Preset icons (SVG strings) ── */
  var ICONS = {
    sparkle:      '<svg viewBox="0 0 24 24"><path d="M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5z"/><circle cx="19" cy="5" r="1.5"/><circle cx="5" cy="19" r="1"/></svg>',
    check_circle: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7 12l3.5 3.5L17 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    gift:         '<svg viewBox="0 0 24 24"><rect x="3" y="10" width="18" height="11" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M12 10v11M3 14h18M8.5 6.5A1.5 1.5 0 0110 5c1 0 2 .8 2 2h-2a1.5 1.5 0 01-1.5-0.5zM15.5 6.5A1.5 1.5 0 0114 5c-1 0-2 .8-2 2h2a1.5 1.5 0 001.5-.5z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    ticket:       '<svg viewBox="0 0 24 24"><path d="M2 8h20v8H2z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M6 8v8M18 8v8" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3 2"/></svg>',
    coin:         '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/><text x="12" y="16" text-anchor="middle" font-size="10" fill="currentColor">$</text></svg>',
    crown:        '<svg viewBox="0 0 24 24"><path d="M3 17L5 9l4 4 3-6 3 6 4-4 2 8H3z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M3 17h18" stroke="currentColor" stroke-width="1.5"/></svg>',
    flame:        '<svg viewBox="0 0 24 24"><path d="M12 2c0 4-5 6-4 11a6 6 0 0011.5-2c.5-4-3-6-2-9-2 1-3 3-3 5s-2 2-2 2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    lightning:    '<svg viewBox="0 0 24 24"><path d="M13 2L3 14h8l-1 8 10-12h-8z" fill="currentColor"/></svg>',
    diamond:      '<svg viewBox="0 0 24 24"><path d="M12 3l5 5-5 13L7 8z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M7 8h10" stroke="currentColor" stroke-width="1.5"/></svg>',
    slot_777:     '<svg viewBox="0 0 24 24"><rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><text x="12" y="16" text-anchor="middle" font-size="9" font-weight="bold" fill="currentColor">777</text></svg>',
    trophy:       '<svg viewBox="0 0 24 24"><path d="M8 3h8v9a4 4 0 01-8 0V3z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 8H5a2 2 0 000 4h3M16 8h3a2 2 0 010 4h-3M12 16v4M8 20h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    star:         '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3L22 9.3l-5 4.9 1.2 7L12 18l-6.2 3.2 1.2-7L2 9.3l7.1-1z" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/></svg>',
  };

  /* ── Default event templates ── */
  var TEMPLATES = {
    daily_checkin:     { title: 'Checked In ✓',        message: 'You earned {{points}} Bara Points.',           ctaGroup: 'coupon' },
    points_earned:     { title: 'Points Added',             message: '+{{points}} Bara Points added to your account.', ctaGroup: 'points' },
    points_redeemed:   { title: 'Points Redeemed',          message: 'Reward code saved to your wallet.',            ctaGroup: 'coupon' },
    coupon_claimed:    { title: 'Coupon Saved',             message: 'Your reward coupon was added to your wallet.',  ctaGroup: 'coupon' },
    coupon_expiring:   { title: 'Reward Expiring Soon',     message: 'Use your coupon before it expires.',           ctaGroup: 'coupon' },
    vip_upgrade:       { title: 'VIP Upgrade',              message: 'You reached {{vip_tier}}!',                    ctaGroup: 'vip'    },
    referral_pending:  { title: 'Referral Reward Pending',  message: 'Your referral reward is under review.',        ctaGroup: 'referral'},
    referral_issued:   { title: 'Referral Reward Issued',   message: 'Your referral reward is in your wallet.',      ctaGroup: 'coupon' },
    review_reward:     { title: 'Review Reward Added',      message: 'You earned Bara Points for your review.',      ctaGroup: 'review' },
    milestone_unlocked:{ title: 'Milestone Unlocked 🏆', message: 'Your streak reward {{milestone}} is ready.', ctaGroup: 'coupon' },
    referral_link_copied: { title: 'Link Copied',           message: 'Your referral link is ready to share.',        ctaGroup: 'referral'},
    coupons_collected: { title: 'Coupons Saved',            message: '{{points}} coupons added to your wallet.',     ctaGroup: 'coupon' },
    review_reward_info:{ title: 'Earn Review Rewards',      message: 'Submit a review to earn Bara Points.',         ctaGroup: 'review' },
    mission_progress:  { title: 'Mission Progress',         message: '{{title}} — {{progress}}/{{goal}} complete.', ctaGroup: 'missions' },
    mission_completed: { title: 'Mission Complete!',        message: 'You completed: {{title}}.',                   ctaGroup: 'missions' },
    mission_rewarded:  { title: 'Mission Reward Earned 🏆', message: '+{{reward_value}} Bara Points for {{title}}.', ctaGroup: 'missions' },
  };

  /* ── Merge user config from window.BB_NOTIF_CFG ── */
  function applyConfig(ext) {
    if (!ext || typeof ext !== 'object') return;
    var notifyOn = cfg.notifyOn;
    var icons    = cfg.icons;
    var customSvg = cfg.customSvg;
    var textOver = cfg.textOverrides;
    var ctaLbl   = cfg.ctaLabels;
    Object.assign(cfg, ext);
    if (ext.notifyOn)      cfg.notifyOn      = Object.assign(notifyOn, ext.notifyOn);
    if (ext.icons)         cfg.icons         = Object.assign(icons, ext.icons);
    if (ext.customSvg)     cfg.customSvg     = Object.assign(customSvg, ext.customSvg);
    if (ext.textOverrides) cfg.textOverrides = Object.assign(textOver, ext.textOverrides);
    if (ext.ctaLabels)     cfg.ctaLabels     = Object.assign(ctaLbl, ext.ctaLabels);
  }

  /* ── SVG sanitizer ── */
  function sanitizeSvg(raw) {
    if (!raw || typeof raw !== 'string') return null;
    var trimmed = raw.trim();
    if (!trimmed.startsWith('<svg') && !trimmed.startsWith('<SVG')) return null;
    // Block dangerous patterns
    if (/<script/i.test(trimmed))       return null;
    if (/on\w+\s*=/i.test(trimmed))     return null;
    if (/javascript:/i.test(trimmed))   return null;
    if (/\bfetch\b|\bxhr\b|\bxmlhttp/i.test(trimmed)) return null;
    if (/<use[^>]+href=["']https?:/i.test(trimmed)) return null;
    return trimmed;
  }

  /* ── Get icon HTML for event type ── */
  function getIconHtml(eventType) {
    if (cfg.iconMode === 'hidden') return '';

    // Custom SVG takes priority
    if (cfg.iconMode === 'custom_svg' || cfg.iconMode === 'preset') {
      var customRaw = cfg.customSvg && cfg.customSvg[eventType];
      if (customRaw) {
        var safe = sanitizeSvg(customRaw);
        if (safe) return '<div class="bb-notif__icon bb-notif__icon--custom" aria-hidden="true">' + safe + '</div>';
        // Unsafe SVG: fall through to preset
        if (cfg.debugMode) console.warn('[BBNotif] Custom SVG for', eventType, 'failed sanitization — using preset.');
      }
    }

    var iconKey = (cfg.icons && cfg.icons[eventType]) || 'sparkle';
    var svgStr  = ICONS[iconKey] || ICONS.sparkle;
    return '<div class="bb-notif__icon" aria-hidden="true">' + svgStr + '</div>';
  }

  /* ── Token interpolation ── */
  function interpolate(str, payload) {
    if (!str || !payload) return str || '';
    return str.replace(/\{\{(\w+)\}\}/g, function (_, key) {
      var v = payload[key];
      return v != null ? String(v) : '';
    });
  }

  /* ── Get notification text ── */
  function getNotifText(eventType, payload) {
    var tpl = TEMPLATES[eventType] || { title: 'Reward', message: '', ctaGroup: 'coupon' };
    var overrides = cfg.textOverrides || {};

    var title   = overrides['title_'   + eventType] || tpl.title;
    var message = overrides['message_' + eventType] || tpl.message;

    title   = interpolate(title,   payload || {});
    message = interpolate(message, payload || {});

    return { title: title, message: message, ctaGroup: tpl.ctaGroup };
  }

  /* ── Determine display mode ── */
  function resolveDisplayMode() {
    var mode = cfg.displayMode;
    if (mode !== 'auto') return mode;
    var isMobile = window.innerWidth <= 600;
    if (isMobile) {
      var mp = cfg.mobilePosition;
      if (mp === 'bottom_sheet') return 'bottom_sheet';
      return 'toast';
    }
    return 'toast';
  }

  /* ── Create container ── */
  function ensureContainer() {
    if (_container && document.contains(_container)) return _container;

    _container = document.getElementById('bb-notif-container');
    if (!_container) {
      _container = document.createElement('div');
      _container.id = 'bb-notif-container';
      document.body.appendChild(_container);
    }

    // Position
    var isMobile = window.innerWidth <= 600;
    _container.setAttribute('data-pos',    cfg.desktopPosition || 'top_right');
    _container.setAttribute('data-mpos',   cfg.mobilePosition  || 'bottom_sheet');
    _container.setAttribute('data-preset', cfg.stylePreset     || 'liquid_glass');

    // CSS variables
    var style = _container.style;
    style.setProperty('--bb-notif-z',      String(cfg.zIndex || 9999));
    style.setProperty('--bb-notif-gap',    (cfg.gap || 10) + 'px');
    style.setProperty('--bb-notif-safe',   (cfg.safeAreaOffset || 0) + 'px');
    if (isMobile) style.setProperty('--bb-notif-w', (cfg.widthMobile || 340) + 'px');
    else          style.setProperty('--bb-notif-w', (cfg.widthDesktop || 360) + 'px');

    // User color overrides
    if (cfg.bgColor)          style.setProperty('--bb-notif-bg',       cfg.bgColor);
    if (cfg.textColor)        style.setProperty('--bb-notif-text',      cfg.textColor);
    if (cfg.subtextColor)     style.setProperty('--bb-notif-subtext',   cfg.subtextColor);
    if (cfg.accentColor)      style.setProperty('--bb-notif-accent',    cfg.accentColor);
    if (cfg.borderColor)      style.setProperty('--bb-notif-border',    cfg.borderColor);
    if (cfg.iconColor)        style.setProperty('--bb-notif-icon',      cfg.iconColor);
    if (cfg.progressColor)    style.setProperty('--bb-notif-progress',  cfg.progressColor);
    if (cfg.shadowOpacity)    style.setProperty('--bb-notif-shadow',    cfg.shadowOpacity);
    if (cfg.borderRadius)     style.setProperty('--bb-notif-radius',    cfg.borderRadius + 'px');
    if (cfg.padding)          style.setProperty('--bb-notif-pad',       cfg.padding + 'px');
    if (cfg.titleSize)        style.setProperty('--bb-notif-title-size',cfg.titleSize);
    if (cfg.messageSize)      style.setProperty('--bb-notif-msg-size',  cfg.messageSize);
    if (cfg.fontWeight)       style.setProperty('--bb-notif-fw',        String(cfg.fontWeight));
    if (cfg.titleTransform)   style.setProperty('--bb-notif-title-transform', cfg.titleTransform);

    // Reduce motion
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (cfg.reduceMotion && prefersReduced) {
      _container.setAttribute('data-bb-reduce-motion', 'true');
    }

    return _container;
  }

  /* ── Confetti ── */
  function spawnConfetti(notifEl) {
    var wrap = document.createElement('div');
    wrap.className = 'bb-notif__confetti';
    var colors = ['#ffd700','#00e5a0','#e040fb','#ff5252','#40c4ff'];
    for (var i = 0; i < 16; i++) {
      var bit = document.createElement('div');
      bit.className = 'bb-notif__confetti-bit';
      bit.style.cssText = [
        'left:' + (Math.random() * 90 + 5) + '%',
        'top:' + (Math.random() * 40) + '%',
        'background:' + colors[i % colors.length],
        'transform:rotate(' + (Math.random() * 360) + 'deg)',
        'animation:bb-confetti-fall ' + (0.7 + Math.random() * 0.5) + 's ease-in ' + (i * 0.05) + 's forwards',
      ].join(';');
      wrap.appendChild(bit);
    }
    notifEl.appendChild(wrap);
  }

  /* ── Coin sparkle ── */
  function spawnCoinSparkle(notifEl) {
    var el = document.createElement('span');
    el.className = 'bb-notif__coin';
    el.textContent = '🪙';
    notifEl.appendChild(el);
  }

  /* ── Play sound ── */
  function playSound(preset) {
    if (!cfg.enableSound || !preset || preset === 'none') return;
    try {
      var ctx = new (root.AudioContext || root.webkitAudioContext)();
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      var freq = { soft_chime: 880, casino_coin: 1046, arcade_blip: 660, success_pop: 784 }[preset] || 880;
      osc.frequency.value = freq;
      osc.type = preset === 'arcade_blip' ? 'square' : 'sine';
      gain.gain.setValueAtTime(0.08, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
      osc.start(); osc.stop(ctx.currentTime + 0.3);
    } catch (e) { /* audio not available */ }
  }

  /* ── Vibrate ── */
  function vibrate() {
    if (!cfg.enableVibration) return;
    try { navigator.vibrate && navigator.vibrate(60); } catch (e) {}
  }

  /* ── Anti-spam check ── */
  function checkSpam(eventType, spamKey) {
    var key = 'bb_reward_notif_seen_' + eventType + (spamKey ? '_' + spamKey : '');
    try {
      if (sessionStorage.getItem(key)) return true;
    } catch (e) {}
    return false;
  }
  function markSeen(eventType, spamKey) {
    var key = 'bb_reward_notif_seen_' + eventType + (spamKey ? '_' + spamKey : '');
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
  }

  /* ── Enforce stack limit ── */
  function enforceStackLimit() {
    var limit = cfg.stackLimit || 3;
    while (_stack.length >= limit) {
      var oldest = _stack.shift();
      if (oldest) removeNotif(oldest.id, true);
    }
  }

  /* ── Remove a notification ── */
  function removeNotif(id, immediate) {
    var idx = _stack.findIndex(function (n) { return n.id === id; });
    if (idx >= 0) {
      clearTimeout(_stack[idx].timer);
      _stack.splice(idx, 1);
    }
    var notifEl = _container && _container.querySelector('[data-notif-id="' + id + '"]');
    if (!notifEl) return;

    // Remove backdrop for mini_modal
    var backdrop = _container.querySelector('.bb-notif__backdrop[data-for="' + id + '"]');
    if (backdrop) backdrop.remove();

    if (immediate) {
      notifEl.remove();
    } else {
      notifEl.classList.add('is-exiting');
      notifEl.classList.remove('is-visible');
      setTimeout(function () { if (notifEl && notifEl.parentNode) notifEl.remove(); }, cfg.exitDurationMs || 220);
    }
  }

  /* ── Core show ── */
  function show(eventType, payload) {
    if (!cfg.enabled) return;

    // Check event-type gate
    var gated = cfg.notifyOn && cfg.notifyOn[eventType] === false;
    if (gated) {
      if (cfg.debugMode) console.log('[BBNotif] Event gated by notifyOn:', eventType);
      return;
    }

    // Anti-spam (once-per-session events)
    var oncePerSession = ['coupon_expiring'];
    var spamKey = payload && (payload.id || payload.coupon_code || payload.date);
    if (oncePerSession.indexOf(eventType) >= 0) {
      if (checkSpam(eventType, spamKey)) {
        if (cfg.debugMode) console.log('[BBNotif] Spam suppressed:', eventType);
        return;
      }
      markSeen(eventType, spamKey);
    }

    var container = ensureContainer();
    var texts     = getNotifText(eventType, payload);
    var mode      = resolveDisplayMode();
    var notifId   = ++_id;
    var anim      = cfg.animationType || 'slide';
    var showGlow  = cfg.enableGlowPulse && mode !== 'banner';
    var showConfetti = cfg.enableConfetti && (cfg.confettiEvents || []).indexOf(eventType) >= 0;
    var showCoins = cfg.enableCoinSparkle && (cfg.confettiEvents || []).indexOf(eventType) >= 0;

    enforceStackLimit();

    // Build CTA HTML
    var ctaHtml = '';
    if (cfg.showCta && texts.ctaGroup && cfg.ctaRoutes && cfg.ctaRoutes[texts.ctaGroup]) {
      var label = (cfg.ctaLabels && cfg.ctaLabels[texts.ctaGroup]) || 'View';
      var route = cfg.ctaRoutes[texts.ctaGroup];
      ctaHtml = '<a class="bb-notif__cta" href="' + route + '">' + label + ' &rarr;</a>';
    }

    // Build progress bar HTML
    var progressHtml = cfg.showProgressBar
      ? '<div class="bb-notif__progress" data-notif-progress></div>'
      : '';

    // Build close button
    var closeHtml = cfg.allowClose
      ? '<button class="bb-notif__close" aria-label="Close notification" data-notif-close="' + notifId + '">&times;</button>'
      : '';

    // ARIA live region: assertive for warnings, polite for the rest
    var ariaLive = eventType === 'coupon_expiring' ? 'assertive' : 'polite';

    // Mode class
    var modeClass = (mode === 'bottom_sheet' || mode === 'toast') ? '' : ' bb-notif--' + mode;

    var notifEl = document.createElement('div');
    notifEl.className    = 'bb-notif' + modeClass;
    notifEl.setAttribute('data-notif-id', String(notifId));
    notifEl.setAttribute('data-anim',     anim);
    notifEl.setAttribute('data-glow',     showGlow ? 'true' : 'false');
    notifEl.setAttribute('role',          mode === 'mini_modal' ? 'dialog' : 'status');
    notifEl.setAttribute('aria-live',     ariaLive);
    notifEl.setAttribute('aria-label',    texts.title + ': ' + texts.message);
    notifEl.innerHTML = (
      getIconHtml(eventType) +
      '<div class="bb-notif__content">' +
        '<p class="bb-notif__title">' + escHtml(texts.title) + '</p>' +
        '<p class="bb-notif__message">' + escHtml(texts.message) + '</p>' +
        ctaHtml +
      '</div>' +
      closeHtml +
      progressHtml
    );

    // Backdrop for mini_modal
    if (mode === 'mini_modal') {
      var backdrop = document.createElement('div');
      backdrop.className = 'bb-notif__backdrop';
      backdrop.setAttribute('data-for', String(notifId));
      backdrop.addEventListener('click', function () { dismiss(notifId); });
      container.appendChild(backdrop);
    }

    container.appendChild(notifEl);

    // Enter animation
    notifEl.classList.add('is-entering');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        notifEl.classList.remove('is-entering');
        notifEl.classList.add('is-visible');

        // Confetti / coins
        if (showConfetti) spawnConfetti(notifEl);
        if (showCoins)    spawnCoinSparkle(notifEl);
      });
    });

    // Progress bar countdown
    var autoMs = (cfg.autoDismissSeconds || 6) * 1000;
    var progressEl = notifEl.querySelector('[data-notif-progress]');
    if (progressEl) {
      progressEl.style.transition = 'transform ' + autoMs + 'ms linear';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          progressEl.style.transform = 'scaleX(0)';
        });
      });
    }

    // Auto-dismiss timer
    var timerHandle = setTimeout(function () { dismiss(notifId); }, autoMs);

    // Pause on hover
    if (cfg.pauseOnHover) {
      var pausedAt = 0;
      var remaining = autoMs;
      notifEl.addEventListener('mouseenter', function () {
        clearTimeout(timerHandle);
        pausedAt = Date.now();
        if (progressEl) {
          var computedWidth = parseFloat(getComputedStyle(progressEl).transform.split(',')[0].replace('matrix(', '')) || 1;
          progressEl.style.transition = 'none';
          progressEl.style.transform = 'scaleX(' + computedWidth + ')';
          remaining = remaining - (pausedAt - (Date.now() - (autoMs - remaining)));
        }
      });
      notifEl.addEventListener('mouseleave', function () {
        if (progressEl) {
          remaining = Math.max(500, remaining - (Date.now() - pausedAt));
          progressEl.style.transition = 'transform ' + remaining + 'ms linear';
          progressEl.style.transform = 'scaleX(0)';
        }
        timerHandle = setTimeout(function () { dismiss(notifId); }, remaining);
        // Update stack record
        var rec = _stack.find(function (n) { return n.id === notifId; });
        if (rec) rec.timer = timerHandle;
      });
    }

    // Close button
    notifEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-notif-close]')) {
        e.stopPropagation();
        dismiss(notifId);
      }
    });

    // Keyboard: Escape on modal
    if (mode === 'mini_modal') {
      notifEl.setAttribute('tabindex', '-1');
      setTimeout(function () { notifEl.focus(); }, 50);
    }

    // Sound + vibration
    playSound(cfg.soundPreset);
    vibrate();

    _stack.push({ id: notifId, timer: timerHandle, el: notifEl });

    if (cfg.debugMode) console.log('[BBNotif] show', eventType, payload, 'id=' + notifId);
    return notifId;
  }

  /* ── Keyboard ESC dismiss ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !_stack.length) return;
    dismiss(_stack[_stack.length - 1].id);
  });

  /* ── HTML escape ── */
  function escHtml(s) {
    return String(s || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  /* ── Public API ── */
  var api = {
    _ready: true,

    show: function (eventType, payload) {
      return show(eventType, payload || {});
    },

    success: function (title, message, options) {
      var opts = options || {};
      var overrideKey = '_custom_' + (++_id);
      TEMPLATES[overrideKey] = { title: title, message: message, ctaGroup: opts.ctaGroup || '' };
      if (cfg.icons) cfg.icons[overrideKey] = opts.icon || 'check_circle';
      return show(overrideKey, opts.payload || {});
    },

    info: function (title, message, options) {
      var opts = options || {};
      var overrideKey = '_custom_' + (++_id);
      TEMPLATES[overrideKey] = { title: title, message: message, ctaGroup: opts.ctaGroup || '' };
      if (cfg.icons) cfg.icons[overrideKey] = opts.icon || 'sparkle';
      return show(overrideKey, opts.payload || {});
    },

    warning: function (title, message, options) {
      var opts = options || {};
      var overrideKey = '_custom_' + (++_id);
      TEMPLATES[overrideKey] = { title: title, message: message, ctaGroup: opts.ctaGroup || '' };
      if (cfg.icons) cfg.icons[overrideKey] = opts.icon || 'flame';
      return show(overrideKey, opts.payload || {});
    },

    dismiss: function (id) {
      return dismiss(id);
    },

    dismissAll: function () {
      _stack.slice().forEach(function (n) { removeNotif(n.id, false); });
      _stack = [];
    },

    configure: function (settings) {
      applyConfig(settings);
      // Rebuild container with new settings
      if (_container) {
        _container.remove();
        _container = null;
      }
    },

    getSettings: function () {
      return Object.assign({}, cfg);
    },
  };

  function dismiss(id) {
    removeNotif(id, false);
  }

  // Apply config from Liquid-injected window.BB_NOTIF_CFG
  if (root.BB_NOTIF_CFG) applyConfig(root.BB_NOTIF_CFG);

  root.BBRewardNotifications = api;

}(window));
